import { createAction } from '@reduxjs/toolkit';

import { AppUrlOptions } from 'utils/url/createAppUrl';

const prefix = 'dashboard';

export const dashboardActions = {
  setLastVisitedUrl: createAction<
    AppUrlOptions<'/dashboard/queues' | '/dashboard/channels'>
  >(`${prefix}/setLastVisitedUrl`),
};
